import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-receipt-report',
  templateUrl: './receipt-report.component.html',
  styleUrls: ['./receipt-report.component.css']
})
export class ReceiptReportComponent implements OnInit {

  public menu_item_id = '104';

  private dp = [];
  branchList = [];

  displayedColumns = ['invoice_no', 'invoice_date', 'supplier_name', 'mobile',
    'total', 'paid', 'remain', 'receipt_date', 'branch_name', 'inv_status', 'detail'];   // , 'supplier_no'

  displayedColumns1 = ['invoice_no', 'invoice_date', 'supplier_name', 'mobile',
    'total', 'paid', 'remain', 'receipt_date', 'branch_name', 'inv_status'];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'from_date': new Date(), 'to_date': new Date(), 'branch_id': '0', 'received': '2', 
    'title': 'تقرير الاستلام' };

  statusList = [{ 'status': 'all', 'status_name': 'الكل', 'status_name_en': 'All' },
  { 'status': '1', 'status_name': 'تم الاستلام', 'status_name_en': 'Received' },
  { 'status': '2', 'status_name': 'لم يتم الاستلام', 'status_name_en': 'Not Received' }];

  Receipt_Report; From_Date; To_Date;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Receipt_Report').subscribe((res: string) => {
      this.Receipt_Report = res;
    });
    this.model['title'] = this.Receipt_Report;

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

  }

  ngOnInit() {
    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });
  }

  search() {

    let obj = { cmd: 'getReceiptRep' };

    if (this.model['from_date'] != undefined) {
      obj['from_date'] = (this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1)
        + "-" + this.model['from_date'].getDate() + ' 00:00:00');
    }

    if (this.model['to_date'] != undefined) {
      obj['to_date'] = (this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1)
        + "-" + this.model['to_date'].getDate() + ' 23:59:59');
    }

    if (this.model['received'] != 'all')
      obj['received'] = this.model['received'];

    let allBranchList = [];
    if (this.model['branch_id'] != '0')
      obj['branch_id'] = this.model['branch_id'];

    else if (this.model['branch_id'] == '0') {
      this.branchList.forEach(element => {
        if (element.branch_id != '0')
          allBranchList.push({ 'branch_id': element.branch_id });
      });
      obj['branch_list'] = allBranchList;
    }

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        console.log(data);

        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

  }

  print() {
    let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
      this.model['from_date'].getDate();

    let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
      this.model['to_date'].getDate();
      
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"><h2>' + this.Receipt_Report + '</h2></td></tr>';
    html_data += '<tr><td width="33%"> ' + this.From_Date + ': ' + from_date + '</td><td width="33%"> ' + this.To_Date + ': ' + to_date + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('rep_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');

  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
